// NOTICE: KAPTION-INTEGRATION
// conversation-tabs.FLAG.2
//
// Is this page running inside Rumo Desktop, and on which platform? The shell
// answers by exposing `window.rumoDesktop` from its preload script; a browser
// has nothing there. Features that only make sense in the shell — anything that
// takes over a keyboard accelerator or a modifier-click the browser already
// owns — ask here first.
import { computed, ref } from 'vue';

const bridge = () =>
  typeof window === 'undefined' ? null : window.rumoDesktop;

// Read once at module scope: the preload runs before any page script, so the
// bridge is either there from the first frame or never.
const desktopBridge = ref(bridge());

export function useKaptionDesktop() {
  const isDesktop = computed(() => Boolean(desktopBridge.value));

  // 'darwin' | 'win32' | 'linux' — the shell passes Node's platform through.
  const platform = computed(() => desktopBridge.value?.platform ?? null);

  const isMac = computed(() => platform.value === 'darwin');
  const isWindows = computed(() => platform.value === 'win32');

  // The tabs namespace is absent on shells older than this feature, so callers
  // must treat it as optional rather than assuming a current Rumo.
  const tabsBridge = computed(() => desktopBridge.value?.tabs ?? null);

  return { isDesktop, platform, isMac, isWindows, tabsBridge };
}

// Tests replace the bridge between cases; nothing in the app calls this.
export const setDesktopBridgeForTesting = value => {
  desktopBridge.value = value ?? null;
};
